import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import * as API from "../../Endpoints/Endpoints";

const ViewCard = () => {
  const [cardData, setCardData] = useState();
  const { cardid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getCardData = async () => {
      try {
        const response = await axios.get(API.GET_CARD_BYID(cardid));
        setCardData(response.data[0]);
      } catch (error) {
        console.error("Error fetching card data:", error);
      }
    };

    if (cardid) getCardData();
  }, [cardid]);

  const deleteCard = async (cardid) => {
    try {
      await axios.delete(API.DELETE_CARD_API(cardid));
      alert("Card deleted successfully");
      navigate("/cardtable");
    } catch (error) {
      alert("Failed to delete card");
      console.error("Error deleting card:", error.response ? error.response.data : error.message);
    }
  };

  const goBack = () => {
    navigate("/cardtable");
  };

  return (
    <div className="py-16 bg-[#f5f5f5] h-full">
      <div className="container px-6 m-auto text-gray-700 md:px-12 xl:px-0">
        <div className="grid gap-6 mx-auto md:w-3/6 lg:w-full lg:grid-cols-1">
          <div className="bg-white rounded-2xl shadow-lg px-8 py-12 sm:px-12 lg:px-8">
            <div className="mb-12 space-y-6">
              {cardData ? (
                <div>
                  <h5 className="text-2xl font-semibold text-[#e64a32]">
                    Card Details
                  </h5>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="flex flex-col">
                      <span className="font-bold">Card Name</span>
                      <span>{cardData.cardname}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Card Group</span>
                      <span>{cardData.cardgroup}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Group Symbol</span>
                      <span>{cardData.grpsymbol}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Name</span>
                      <span>{cardData.gamename}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Category</span>
                      <span>{cardData.gamecategory}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Complexity</span>
                      <span>{cardData.complexity}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Goal</span>
                      <span>{cardData.goal}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Age Group</span>
                      <span>{cardData.age}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Difficulty Level</span>
                      <span>{cardData.difflevel}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Implementation</span>
                      <span>{cardData.implementation}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-6 space-x-4">
                    <button
                      className="bg-[#e64a32] text-white hover:bg-[#e64a32] font-bold py-2 px-4 rounded"
                      onClick={() => deleteCard(cardData.cardid)}
                    >
                      Delete
                    </button>
                    <button
                      className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded"
                      onClick={goBack}
                    >
                      &#8592; Go Back
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-center text-gray-500">Loading card details...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCard;
